// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"348":"47ef9ac8","360":"2944656e","445":"a51e664b","536":"08cbc599","559":"9367bce3","722":"7f0697c9","827":"04e4fdca","944":"9367bce3","994":"22bb574f"}[chunkId] + ".chunk.css";
};